import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Icon } from '@/components/common/Icon';

interface CommitBarProps {
  isCommittable: boolean;
  isCommitting: boolean;
  onCommit: () => void;
}

export function CommitBar({ isCommittable, isCommitting, onCommit }: CommitBarProps) {
  const { t } = useTranslation('clientImport');

  return (
    <Card
      padding="sm"
      className="sticky bottom-0 z-10 flex flex-wrap items-center justify-between gap-3 border-t border-zooborder shadow-lg"
    >
      <p className="text-xs text-zoomuted">
        {isCommittable === true ? t('commitBar.reuploadHint') : t('commitBar.disabledHint')}
      </p>
      <Button
        disabled={isCommittable === false}
        isLoading={isCommitting}
        onClick={onCommit}
        className="gap-1.5"
      >
        {isCommitting === true ? null : <Icon name="Upload" />}
        {isCommitting === true ? t('commitBar.committing') : t('commitBar.commit')}
      </Button>
    </Card>
  );
}
